import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup } from '@angular/forms';
import { UserService } from '@app/areas/user/user.service';
import { ResetPasswordDTO } from '@app/_models/user/user';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { BaseComponent } from '@app/base/basecomponent';
import { PersistenceService } from '@app/_services/persistence.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html'
})
/** reset-password component*/
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  public resetpwForm: UntypedFormGroup;
  public loading = false;
  public actionCompleted = false;

  private user: string;
  private token: string;

  get f() { return this.resetpwForm.controls; }

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private persistence: PersistenceService
  ) {
    super();
  }

  ngOnInit() {
    //this.translate.setDefaultLang('fi');
    this.translate.use(this.persistence.getLang());

    this.subscription.add(this.activatedRoute.queryParams.subscribe(params => {
      this.user = params['user'];
      this.token = params['token'];
    }));

    if (!this.user || !this.token) {
      //this.router.navigate(['./login']);
    }

    this.resetpwForm = this.formBuilder.group({
      passphrase: ['', [Validators.required]],
      confirmPassphrase: ['', [Validators.required]]
    }, { validators: [this.checkPasswordsMatch] });
  }

  onSubmit() {
    if (!this.resetpwForm.valid) {
      if (this.resetpwForm.errors?.notSame) {
        this.formError(this.resetpwForm, 'user.errors.passphrases_dont_match');
        return;
      }
      this.formError(this.resetpwForm, 'login.errors.reset_form');
      return;
    }

    this.loading = true;
    var dto = this.createResetPasswordDTO();

    this.userService.resetPassword(dto).pipe(first()).subscribe(data => {
      this.loading = false;
      this.actionCompleted = true;
    }, (error) => {
      this.loading = false;
      this.errorHandler.applyErrors(this.resetpwForm, error);
    });
  }


  createResetPasswordDTO(): ResetPasswordDTO {
    var data = new ResetPasswordDTO();
    data.user = this.user;
    data.token = this.token;
    data.passphrase = this.f.passphrase.value;

    return data;
  }

  /**
   * Checks passwords match
   * @param group
   */
  checkPasswordsMatch(group: UntypedFormGroup) {
    let pass = group.get('passphrase').value;
    let confirmPass = group.get('confirmPassphrase').value;
    return pass === confirmPass ? null : { notSame: true }
  }
}
